import ErrorPageLayout from "@components/error-page-layout";
import { FC, useEffect } from "react";
import Error403Image from "@assets/403.svg";
import { useTitle } from "@contexts/title.context";

const ForbiddenPage: FC = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle("Access Denied");

    return () => {
      setTitle("");
    };
  }, [setTitle]);

  return (
    <ErrorPageLayout
      title="Access Denied"
      description="You do not have permission to access this page."
      image={<img src={Error403Image} alt="access denied" decoding="async" loading="eager" />}
    />
  );
};

export default ForbiddenPage;
